<template>
  <div class="p-grid">
    <Card class="style p-col" style="width: 100%">
      <template #title>
        <h3 class="p-m-0">
          <strong>Settings</strong>
        </h3>
      </template>
      <template #content>
        <h3 class="subhead">AJAX actions</h3>
        <Button class="p-button-success">Ajax Submit</Button>
      </template>
    </Card>
  </div>
</template>
